@let notification = notificationData();
@let listedSeat = notification.type === 'convertMultipleServicesToBundle' ? notification.existingSeat : undefined;

<fcom-notification
  class="wrap"
  data-testid="overlapping-services-notification"
  [theme]="notification.theme"
  [iconName]="notification.icon"
  [linkText]="notification.ctaTextKey | finLocalization: { category: notification.ctaCategoryKey | finLocalization }"
  [secondaryLinkText]="'ancillaries.overlappingServicesNotification.keepSelection' | finLocalization"
  (linkClick)="continueToSelection(notification.existingSeat?.seatNumber)"
  (secondaryLinkClick)="cancelSelection.emit()"
>
  {{
    notification.messageKey
      | finLocalization
        : {
            currentCategory: notification.currentCategoryKey | finLocalization,
            overlapCategory: notification.overlapCategoryKey | finLocalization,
          }
  }}

  @if (notification.overlappingServices.length > 1 || listedSeat) {
    <ul class="ms-large-l" data-testid="overlapping-services-list">
      @if (listedSeat; as seat) {
        <li data-testid="overlapping-service-list-item">
          {{ seat.seatTypeKey | finLocalization }} {{ seat.seatNumber }}
        </li>
      }
      @for (service of notification.overlappingServices; track service.id) {
        <li data-testid="overlapping-service-list-item">{{ service.displayName }}</li>
      }
    </ul>
  }
</fcom-notification>
